import { timerTelemetry as coreEventsTimerTelemtry } from 'core-events';
import { fetchTypeahead as internalFetchTypeahead } from 'sb-shell/actions/fetchTypeahead';
import { getContentClassByContentType, SearchFilterContentTypes } from 'search-gateway-client';

import { ContentCollection } from '../elements/NavSearchElements/NavSearchTypes';

export type TypeaheadResponse = {
    collections: ContentCollection[];
    keywords: string[];
    latestCollections: object[];
    relatedContentTypesAndKeywords: object[];
    message: string;
};

const fetchTypeahead = async (
    contentType: SearchFilterContentTypes,
    query = '',
    typeaheadEnhancementExperiment = false,
    timerTelemetry: () => Promise<void> = () => coreEventsTimerTelemtry('search.frontEnd.typeAhead'),
) => {
    const typeaheadTimer = timerTelemetry;
    const contentClass = getContentClassByContentType(contentType);
    const mappedContentClass = contentClass === 'image' ? 'images' : contentClass;
    const data = await internalFetchTypeahead(mappedContentClass, encodeURIComponent(query));
    typeaheadTimer();

    if (typeaheadEnhancementExperiment || data?.keywords?.length) {
        return data;
    }
};

export default fetchTypeahead;
